import { FC } from 'react';
import { FilterModel } from 'ts/hotel/classes/FilterModel';
import Rating from 'react-stars';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface FilterResultStarsProps {
  filter: FilterModel;
  onFilterChange: (filter: FilterModel) => void;
}

const FilterResultStars: FC<FilterResultStarsProps> = (props) => {
  const stars = [3, 4, 5];

  const onChange = (option: number) => {
    if (!props.filter.stars.options.includes(option)) return;
    const newValues = [...props.filter.stars.value];
    if (newValues.includes(option)) {
      newValues.splice(newValues.indexOf(option), 1);
    } else {
      newValues.push(option);
    }

    newValues.sort((a, b) => a - b);

    props.onFilterChange({
      ...props.filter,
      stars: { ...props.filter.stars, value: newValues },
    });
  };

  return (
    <div className="hotel-result-filter-input star star2" data-assistant-target="stars">
      <div className="star-wr">
        <div
          onClick={() => onChange(2)}
          className={'cur-poi' + (!props.filter.stars.options.includes(2) ? ' disabled' : '')}
        >
          <Rating value={1} count={1} color2="#4b71a3" />
        </div>
        {stars.map((option, index) => (
          <div
            className={
              'cur-poi' +
              (props.filter.stars.value.includes(option) ? ' active' : '') +
              (!props.filter.stars.options.includes(option) ? ' disabled' : '')
            }
            key={index}
            onClick={() => onChange(option)}
          >
            {option}
          </div>
        ))}
      </div>
    </div>
  );
};

export default withErrorBoundary(FilterResultStars, 'FilterResultStars');
